import React, { useState } from "react";
import { VideoModal } from "@/components/public/VideoModal";
import { Play } from "lucide-react";

const CONTAINER = "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8";

// Public "More videos" library/carousel. Hidden unless Admin enables it
// (content.video_library.enabled) and at least one enabled video exists.
export const VideoLibrary = ({ content }) => {
  const lib = content?.video_library || {};
  const videos = (content?.videos || [])
    .filter((v) => v && v.enabled !== false && v.video_url)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  const [active, setActive] = useState(null);

  if (!lib.enabled || videos.length === 0) return null;

  return (
    <section className="py-14 sm:py-20 bg-[#FBF6EC] mmm-grain" data-testid="video-library-section">
      <div className={CONTAINER}>
        <p className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#9C1E22]">Watch &amp; learn</p>
        <h2 className="mt-2 text-2xl sm:text-3xl font-display font-bold text-[#1C4358]">
          {lib.title || "More from MovingMyMama"}
        </h2>
        {lib.subtitle ? (
          <p className="mt-2 text-[16px] text-[#4B5563] max-w-2xl leading-relaxed">{lib.subtitle}</p>
        ) : null}
        <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {videos.map((v, i) => (
            <button
              key={v.id || i}
              type="button"
              onClick={() => setActive(v)}
              data-testid={`video-lib-card-${i}`}
              className="group text-left rounded-2xl overflow-hidden bg-white border border-[#1C4358]/10 shadow-sm hover:shadow-md transition-all"
            >
              <div className="relative h-44 bg-[#1C4358]">
                {v.poster_url ? (
                  <img src={v.poster_url} alt={v.title || "Video"} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
                ) : null}
                <span className="absolute inset-0 bg-black/20" />
                <span className="absolute inset-0 flex items-center justify-center">
                  <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-white/90 text-[#9C1E22] shadow-lg transition-transform group-hover:scale-110">
                    <Play size={22} className="ml-0.5 fill-current" />
                  </span>
                </span>
                {v.featured ? (
                  <span className="absolute top-3 left-3 text-[11px] font-bold px-2 py-0.5 rounded bg-[#DEE029] text-[#1C4358]">Featured</span>
                ) : null}
              </div>
              <div className="p-5">
                <h3 className="font-display font-semibold text-[#1C4358] text-[17px]">{v.title}</h3>
                {v.description ? (
                  <p className="mt-1.5 text-[14px] text-[#4B5563] leading-relaxed line-clamp-3">{v.description}</p>
                ) : null}
              </div>
            </button>
          ))}
        </div>
      </div>
      <VideoModal
        open={!!active}
        onOpenChange={(o) => !o && setActive(null)}
        url={active?.video_url}
        title={active?.title}
        description={active?.description}
        poster={active?.poster_url}
        testid="video-lib-modal"
      />
    </section>
  );
};

export default VideoLibrary;
